angular.module('gym.dashboard').factory('Dashboard', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var params;
  params = $rootScope.toParams;
  return Restangular.one('gyms', params.gymId).all('dashboard');
}]);
